<template>
    <crm-content>
        <template v-slot:actionLeft>
            <h5>Export</h5>
        </template>

        <div class="flex flex-nowrap justify-between">
            <transition name="slide-fade-right" appear>
                <div class="flex flex-nowrap justify-between w-full">
                    <vx-card title="Filters" class="w-full">
                        <vx-list-aggregator
                            class="mb-2"
                            label="Request Status"
                            id-key="id"
                            display-key="name"
                            show-on-focus
                            v-model="selectedRequestStatuses"
                            :search_groups="request_status_list"
                            remove-validation-padding
                        ></vx-list-aggregator>

                        <div
                            v-for="date in dates"
                            :key="date.label"
                            class="flex flex-wrap justify-between w-full"
                        >
                            <h6 class="mb-2">{{ date.label }}</h6>

                            <div class="w-full items-center flex">
                                <vx-date-input
                                    class="w-1/2"
                                    v-model="date.fromDate"
                                    label="From"
                                    clearable
                                />
                                <vx-basic-icon class="mx-2" icon="ArrowRightIcon" />
                                <vx-date-input
                                    class="w-1/2"
                                    v-model="date.toDate"
                                    label="To (inclusive)"
                                    clearable
                                />
                            </div>
                        </div>
                        <vx-list-aggregator
                            class="mb-2"
                            label="Service Task Status"
                            id-key="id"
                            display-key="description"
                            show-on-focus
                            v-model="selectedServiceTaskStatuses"
                            :search_groups="task_status_list"
                            remove-validation-padding
                        ></vx-list-aggregator>
                        <vs-button @click="startExport">Export as Excel</vs-button>
                    </vx-card>
                    <!-- <vx-card
                        title="Selected Columns for Export"
                        class="ml-6 w-1/2"
                        style="height: 600px"
                    >
                        <vx-column-selector
                            ref="columnSelector"
                            :style="scrollHeight"
                            @save="save"
                            :columns="selectedItems"
                            :defaultColumns="default_fumigation_columns"
                        >
                            <template slot="buttons"> <div></div></template>
                        </vx-column-selector>
                    </vx-card> -->
                </div>
            </transition>
        </div>

        <export-excel
            v-if="readyForExport"
            :sheets="sheets"
            filename="filename"
            style="display: none"
            @completed="completedExport"
        >
        </export-excel>
    </crm-content>
</template>

<script>
import { mapGetters } from 'vuex'
import CrmContent from '../../crm/components/CrmContent'
import ExportExcel from '@/components/excel/ExportExcelUpdated.vue'

const defaultSheet = [
    {
        sheetname: 'Service Tasks',
        columns: [],
        data: []
    }
]

export default {
    name: 'custom-export',
    components: { ExportExcel, CrmContent },
    mixins: [],
    data() {
        return {
            search: '',
            readyForExport: false,
            loadedReport: null,
            reportName: '',
            dates: [
                {
                    label: 'Request Completed Date',
                    filter: 'requestCompleted',
                    fromDateMenu: false,
                    toDateMenu: false,
                    fromDate: null,
                    toDate: null
                },
                {
                    label: 'Service Task Date',
                    filter: 'serviceTaskDate',
                    fromDateMenu: false,
                    toDateMenu: false,
                    fromDate: null,
                    toDate: null
                }
            ],

            selectedRequestStatuses: [],
            selectedServiceTaskStatuses: [],
            sheets: []
        }
    },
    computed: {
        ...mapGetters({
            serviceTaskStatuses: 'maarima/serviceTaskStatuses',
            requestStatuses: 'maarima/requestStatuses',
            taskTypes: 'maarima/taskTypes'
        }),

        task_status_list() {
            return {
                Statuses: {
                    data: this.serviceTaskStatuses,
                    idfield: 'id',
                    searchOn: 'name',
                    displayText: 'name'
                }
            }
        },
        request_status_list() {
            return {
                Statuses: {
                    data: this.requestStatuses,
                    idfield: 'id',
                    searchOn: 'name',
                    displayText: 'name'
                }
            }
        },

        taskTypeFields() {
            const uniqueTaskTypeFields = new Set()

            // Iterate through the JSON data and extract taskTypeFields
            this.taskTypes.forEach((item) => {
                if (item.taskTypeFields && item.taskTypeFields.length > 0) {
                    item.taskTypeFields.forEach((field) => {
                        uniqueTaskTypeFields.add(field) // Store objects directly
                    })
                }
            })

            // Convert Set back to an array
            const uniqueTaskTypeFieldsArray = Array.from(uniqueTaskTypeFields)

            return uniqueTaskTypeFieldsArray
        }
    },
    watch: {},
    methods: {
        getTaskTypeFieldById(taskTypeFieldId) {
            return this.taskTypeFields.first((x) => x.id == taskTypeFieldId)
        },

        getFieldMappingValueFromTaskType(taskTypeFieldId, value) {
            let taskTypeField = this.getTaskTypeFieldById(taskTypeFieldId)
            if (taskTypeField.fieldType.name == 'Aggregator') {
                if (!value) {
                    return []
                }
                let split = value.split(',').map((x) => {
                    return parseInt(x)
                })
                return taskTypeField.taskTypeFieldOptions
                    .filter((x) => split.includes(x.id))
                    .map((x) => x.value)
                    .join(',')
            } else if (taskTypeField.fieldType.name == 'Select') {
                if (!value) {
                    return null
                }
                let split = parseInt(value)
                let option = taskTypeField.taskTypeFieldOptions.first((x) => x.id == split)
                if (option) {
                    return option.value
                }
                return null
            } else if (taskTypeField.fieldType.name == 'Checkbox') {
                if (value == 'true') {
                    return 'Yes'
                } else if (value == 'false') {
                    return 'No'
                }
            } else if (taskTypeField.fieldType.name == 'Text') {
                return value
            } else if (taskTypeField.fieldType.name == 'Radio') {
                return value
            } else if (taskTypeField.fieldType.name == 'Date') {
                return new Date(value)
            } else if (taskTypeField.fieldType.name == 'Currency') {
                return Number(value)
            } else {
                return value
            }
        },

        async startExport() {
            this.loading = true

            // var selectedFields = this.selectedItems
            //     .filter((v) => v.isSelected)
            //     .map((v) => this.real_fumigation_columns[v.value])

            var response = await this.$api.maarima.export.fetch(
                this.selectedRequestStatuses,
                this.selectedServiceTaskStatuses,
                this.dates
            )
            if (response && response.length == 0) {
                this.notifyWarning('Warning', `No data to Export`, 4000)
                this.loading = false
                return
            }

            if (!response) {
                this.notifyWarning(
                    'Warning',
                    `Too much data to export, please reduce your date range`,
                    4000
                )
                this.loading = false
                return
            }

            var keys = Object.keys(response[0])

            var idx = keys.findIndex((k) => k == 'serviceTaskAdditionalDetails')
            delete keys[idx]

            this.sheets[0].columns = keys.map((key) => {
                return {
                    title: key,
                    value: key,
                    visible: true
                }
            })
            let columns = this.sheets[0].columns
            response.forEach((row) => {
                if (row['serviceTaskAdditionalDetails']) {
                    row['serviceTaskAdditionalDetails'].forEach((detail, index) => {
                        let exists = columns.any((c) => {
                            if (!c) {
                                return false
                            }
                            return c.title == detail.taskTypeFieldName
                        })
                        if (!exists) {
                            columns.push({
                                title: detail.taskTypeFieldName,
                                value: detail.taskTypeFieldName,
                                visible: true
                            })
                        }
                        row[detail.taskTypeFieldName] = this.getFieldMappingValueFromTaskType(
                            detail.taskTypeFieldId,
                            detail.value
                        )
                    })
                }
            })

            var finalData = []

            // convert all True and False values to 'Yes' and 'No'

            response.forEach((task) => {
                var f_keys = Object.keys(task)

                var parsed_fumigation = f_keys
                    .map((key) => {
                        return {
                            key: key,
                            value: task[key]
                        }
                    })
                    .toObject(
                        (item) => item.key,
                        (item) =>
                            item.value === true ? 'Yes' : item.value === false ? 'No' : item.value
                    )

                finalData.push(parsed_fumigation)
            })

            this.sheets[0].data = finalData

            this.readyForExport = true
            this.loading = false
        },
        completedExport() {
            this.readyForExport = false
            this.sheets = this.deepCopy(defaultSheet)
        }
    },
    async created() {
        // this.selectedItems = this.deepCopy(defaultColumns.fumigation)
        this.sheets = this.deepCopy(defaultSheet)
        // this.resetAvalibleItems()
    }
}
</script>

<style scoped>
/* .v-toolbar >>> .v-toolbar__content {
        padding: 0;
    } */
</style>
